module.exports = __webpack_public_path__ + "static/media/man (2).84d3b1d8.png";